import React from "react";
import classes from "./footerBottom.module.css";

const footerBottom = (props) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className={`${classes.copyright} text-center`}>
            Copyright © 2025,Hettich India Pvt. Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default footerBottom;
